import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PdfMakeWrapper, Img } from 'pdfmake-wrapper';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

import { Txt, Columns, Table, Ul, Ol } from 'pdfmake-wrapper';
import { AuthService } from 'src/app/services/auth.service';
@Component({
  selector: 'app-racivdoc',
  templateUrl: './racivdoc.component.html',
  styleUrls: ['./racivdoc.component.scss']
})
export class RacivdocComponent implements OnInit {

  constructor(public authService: AuthService,public router: Router) { }
url=""
id_raci=0
  ngOnInit() {
   
    this.url
    var c=this.router.url;
    var c2=c.split("?");
    console.log(c)
    this.id_raci=Number(c2[1].replace("=",""));
    
    if(this.id_raci==undefined){
      this.id_raci=0
    }else{
      this.raci();
    }
  }
  
  nom_cliente;tarea;area;rel_pa;
  
  async raci(){
    
    const pdf = new PdfMakeWrapper(); 
    pdf.pageOrientation("portrait"); 
 
    pdf.pageMargins([35,58, 35, 35]); 
    var cliente_name=this.nom_cliente;
    this.tarea=[];
            this.area=[];
          await this.authService.service("/api/get_proceso",{id_raci:this.id_raci})
          .then(
            data => {
              var dat = JSON.stringify(data);
              var res = JSON.parse(dat);                      
              for(var i=0;i<res.length;i++){
                //console.log(res[i]);            
                this.tarea.push( { id:res[i].id, proceso:res[i].Titulo,descripcion:res[i].Descripcion,idx:res[i].idx}
                );
              }
            },
            error => {
                var de= JSON.stringify(error);
                var di = JSON.parse(de);
            }); 
            await this.authService.service("/api/get_area",{id_raci:this.id_raci})
            .then(
              data => {
                var dat = JSON.stringify(data);
                var res = JSON.parse(dat);                        
                for(var k=0;k<res.length;k++){
                  
                  var tx_area= "";
                if(res[k].id_ant==0){
                  tx_area=res[k].area
                }else{
                  if(res[k].role.toString()==""){
                    tx_area=res[k].area;
                  }else{
                    tx_area=res[k].role;
                  }
                }
                  this.area.push({ id:res[k].id,
                    area:tx_area,
                    idx:res[k].idx});        
                }
              },
              error => {
                  var de= JSON.stringify(error);                                  
              });
              var twidth=3000;
              if(this.tarea.length>40){
                pdf.pageSize( {width: 3900,height: 2000});
                twidth=3000;
              }else if(this.tarea.length>30){
                pdf.pageSize( {width: 2700,height: 1500});
                twidth=2000;
              }else{
                pdf.pageSize( {
                  width: 1850,
                  height: 1000
                });
                twidth=1500;
              }
              pdf.pageOrientation("landscape"); 
               var id_cliente
              await this.authService.service("/api/get_raci_id",{id:this.id_raci})
              .then(
                data => {
                  var dat = JSON.stringify(data);
                  var res = JSON.parse(dat);                 
                  raciname=res[0].descipcion;
                  id_cliente=res[0].id_cliente;
                },
                error => {
                    var de= JSON.stringify(error);
                    var di = JSON.parse(de);
                });
                var client_name=this.nom_cliente;
                await this.authService.service("/api/get_cliente_byid",{id:id_cliente})
                .then(
                  data => {
                    var dat = JSON.stringify(data);
                    var res = JSON.parse(dat);  
                   
                    try {
                      client_name=res[0].razonsocial;  
                    } catch (error) {
                      client_name="";
                    }
                    
                  },
                  error => {
                      var de= JSON.stringify(error);
                      var di = JSON.parse(de);
                  });
             
              
              var raciname;               
              pdf.add(new Txt("R: Responsible     A: Accountable     C: Consulted     S: Support     I: Informed: ")              
              .alignment('center').color("black").bold().fontSize(16).end);  
              pdf.add(new Txt( " ").alignment('left').color("black").bold().fontSize(18).end);  
              pdf.add(new Table([             
                [{text:"Company: "+client_name}, 
                {text:"Title: "+raciname,color:"red",alignment:'right'}], 
              ]).widths([twidth/2,twidth/2]).layout('noBorders').fontSize(16).bold().alignment('left').end);
              
              var rows_=(this.tarea.length+1);
              var row_i=Math.ceil(twidth/rows_);
              var wdt_=[];
              for(var l=0;l<rows_;l++){
                wdt_.push(row_i);                  
              }
              var column1 =new Array();
              pdf.styles({
                section: {
                        }});
              column1.push({ text: 'Process',color:'#FFFFFE',fillColor:'#e8c82f'
                  ,borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']});
              for(var l=0;l<(this.tarea.length);l++){
                //console.log(this.tarea[i]);            
                column1.push({ text: this.tarea[l].proceso,color:'#FFFFFE',fillColor:'#e8c82f',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']});
              }
              pdf.add(new Table([column1
              ]).widths(wdt_).decorationColor("#000000").style("section").fontSize(11).bold().alignment('left').end);
              var column2=new Array();      
              column2.push({ text: 'Department',color:"#000000",fillColor:"#cccccc",fontsize:10,borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']});
              for(var l=0;l<(this.tarea.length);l++){
                column2.push({ text: this.tarea[l].descripcion,color:"#FFFFFE",fillColor:"#e8c82f",borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']});
              }
              pdf.add(new Table( [column2     
                ]).widths(wdt_).fontSize(9).alignment('left').end);
              this.rel_pa=[];     
              await  this.authService.service("/api/get_pa_2",{id_raci:this.id_raci})
              .then(
                  data => {
                    var dat = JSON.stringify(data);
                    var res = JSON.parse(dat);             
                    for(var i=0;i<res.length;i++){      
                      this.rel_pa.push(
                          {id:res[i].id,
                          id_p:res[i].id_tarea,
                          id_a:res[i].id_area,
                          rol:res[i].rol,
                          c:"X"});
                    }       
                  },
                  error => {
              }); 
              
              for(var l=0;l<(this.area.length);l++){
                //console.log(this.area[j])
                var column3=new Array();      
                column3.push({ text:this.area[l].area,color:"#535442",fillColor:"#cccccc",fontSize:10 ,
                borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']});
                for(var m=0;m<(this.tarea.length);m++){
                  var bnd=0;
                  var rol="";
                  for(let k=0;k<this.rel_pa.length;k++){
                    if(this.rel_pa[k].id_p==this.tarea[m].id  &&  this.rel_pa[k].id_a==this.area[l].id){
                      bnd=1;
                      rol=this.rel_pa[k].rol;           
                    }          
                  }        
                  switch (rol) {
                    case 'R':
                    case 'AR':column3.push({ text: rol,color: '#ffffff',fillColor: '#f54242',fontSize:20,alignment:'center',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']});                
                      break;
                    case 'A':column3.push({ text: rol,color: '#3a3fd6',fontSize:20,alignment:'center',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']});            
                      break;
                    case 'C':column3.push({ text: rol,color: '#d6733a',fontSize:20,alignment:'center',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']});            
                      break;
                    case 'S':column3.push({ text: rol,color: '#4fd63a',fontSize:20,alignment:'center',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']});            
                      break;
                    case 'I':column3.push({ text: rol,color: '#000000',fontSize:20,alignment:'center',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']});            
                      break;
                    default:column3.push({ text:"",borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']});break;
                  }                
                }
                pdf.add(new Table(
                  [               
                    column3    
                  ]
                ).widths(wdt_).bold().alignment('left').end);
              }
              pdf.create().download();  
              setTimeout(function(){
                window.close();
              },4000);//
  }
}
